export const installSteps = ['고객 선택', '단말기 선택', '검침정보 수정', '설치 검토']

export const asInstallSteps = ['AS 선택', 'A/S', '검침정보 수정', 'AS 검토']
